import React from 'react';
import { Guest } from './seatingTypes';

interface PrintSeatProps {
  guest: Guest | undefined;
  seatIndex: number;
  seatType?: 'left' | 'right' | 'end' | 'top' | 'bottom';
  catererIndex: Map<number, number>;
}

const PrintSeat: React.FC<PrintSeatProps> = ({ guest, seatIndex, seatType, catererIndex }) => {
  const seatClass = seatType ? `seat-${seatType}` : '';
  const isCaterer = guest?.messageForCaterer && guest?.message;
  const refNum = guest ? catererIndex.get(guest.id) : undefined;
  const seatNum = seatIndex + 1;

  return (
    <div className={`seat ${guest ? 'occupied' : 'empty'} ${seatClass} ${isCaterer ? 'print-seat-caterer' : ''}`}>
      {guest ? (
        <div className={`guest-card print-static ${isCaterer ? 'caterer-highlight' : ''}`}>
          <span className="guest-name">{refNum ? `*${refNum}` : seatNum}</span>
        </div>
      ) : (
        <div className="seat-number-wrapper">
          <span className="seat-number">{seatNum}</span>
        </div>
      )}
    </div>
  );
};

export default PrintSeat;
